import React from "react";
import {connect} from "react-redux";
import {Dialog, Button, Typography} from "@material-ui/core";
import {CheckCircle, Cancel} from '@material-ui/icons';
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import axios from "axios";
import {userService} from "../services/UserService";
import config from '../config.json';
import {INotificacion, IParcela, ISections} from "../types";


interface IProps {
    nota: string
    close(): void
}

interface IState {
}

class Notificacion extends React.Component<IProps, IState>{

    state:IState = {
    }


    render() {
        return (
            <Dialog
                open={this.props.nota !== ''}
                onClose={() => this.props.close()}
                PaperProps={{
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: "center",
                        overflow: "hidden"
                    }
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Typography
                    style={{
                        fontSize: 14,
                        margin: 20,
                        fontFamily: "Poppins"
                    }}
                >
                    {this.props.nota}
                </Typography>
            </Dialog>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    nota: state.navegacion.dialogs.nota
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    close: () => dispatch({type: "open-nota-dialog", callback:""})
});

export default connect(mapStateToProps, mapDispatchToProps)(Notificacion);